var _defs, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 349.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#f0f0f0;}.cls-3{fill:#f5f5f5;}.cls-4{fill:#fafafa;}.cls-5{fill:#407bff;}.cls-13,.cls-23,.cls-6,.cls-7,.cls-9{fill:#fff;}.cls-11,.cls-22,.cls-6{opacity:0.2;}.cls-19,.cls-7{opacity:0.4;}.cls-8{opacity:0.7;}.cls-10,.cls-17{fill:#819fda;}.cls-12{fill:#cb7a63;}.cls-13,.cls-15,.cls-20{opacity:0.3;}.cls-14{fill:#263238;}.cls-16{fill:#b74d3c;}.cls-17{opacity:0.1;}.cls-18{fill:#7593d2;}.cls-20,.cls-22{isolation:isolate;}.cls-21{fill:#ce7a63;}.cls-23,.cls-24{opacity:0.6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 304.81,
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 304.81,
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 416.78,
    y: 320.9,
    width: 33.12,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 322.53,
    y: 323.62,
    width: 8.69,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 396.59,
    y: 311.62,
    width: 19.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.46,
    y: 313.3,
    width: 43.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.47,
    y: 317.52,
    width: 93.68,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.37,158.68c12.29,0,46.77,5,46.77-13.49,0-15.73-16.85-14.57-16.85-14.57s.48-13.63-14.53-15.45C154.37,113.31,152,128,152,128s-26.72-9.38-22.66,14.16c0,0-14.81-2.61-14.81,8C114.57,162,142.46,158.65,154.37,158.68Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.88,298.71c25,.07,94.92,11.53,94.92-30.88,0-36-34.19-33.39-34.19-33.39s1-31.23-29.48-35.38c-31.25-4.26-36,29.48-36,29.48s-54.25-21.48-46,32.43c0,0-30.07-6-30.07,18.28C58.1,306.37,114.7,298.64,138.88,298.71Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.09,302.46c-13.8,0-52.51,6.38-52.51-17.08,0-19.94,18.92-18.47,18.92-18.47s-.55-17.28,16.31-19.57c17.28-2.36,19.89,16.31,19.89,16.31s30-11.89,25.45,17.94c0,0,16.63-3.32,16.63,10.11C276.78,306.7,245.47,302.42,232.09,302.46Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.15,204.16c13.77,0,52.38,5.31,52.38-14.23,0-16.6-18.87-15.38-18.87-15.38s.54-14.39-16.27-16.3c-17.24-2-19.85,13.58-19.85,13.58s-29.93-9.9-25.37,14.94c0,0-16.6-2.76-16.6,8.42C264.57,207.69,295.81,204.13,309.15,204.16Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.09,382.28l20.12-130.45,59.84-75.55,20.4-86s49.46,47.78,50.83,49,12.26,130.24,13.77,132.21S448.77,296,448.77,296l6.61,85.94Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "268.09 304.69 296.77 191.97 337.4 153.23 345.01 202.26 355.25 146.49 366.87 165.5 364.34 99.95 366.36 78.97 373.18 92.89 368.45 12.65 402.93 13.44 410.11 51.32 419.28 61.69 433.05 193.9 448.77 218.36 455.38 304.3 268.09 304.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.35,90.67l20.48,66.27,12.21,9.7s6.43,26.93,6.36,25.21-.74-31.9-.74-31.9l3.16-24.62-8-43.86Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "433.05 193.9 437.83 216.18 448.77 218.36 433.05 193.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M356.06,337.44c21.88.06,83.2,10.11,83.2-27.07,0-31.58-30-29.26-30-29.26s.87-27.37-25.84-31c-27.39-3.73-31.52,25.84-31.52,25.84s-47.54-18.83-40.31,28.43c0,0-26.35-5.26-26.35,16C285.27,344.16,334.88,337.38,356.06,337.44Z",
    transform: "translate(0 -77.59)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.56,
    y: 313.3,
    width: 6.33,
    height: 0.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-3",
    cx: 252.14,
    cy: 338.1,
    rx: 193.89,
    ry: 11.32
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Coin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M403.35,95.08a17.49,17.49,0,0,1-17.49,17.49c-.39,0-.78,0-1.17,0a17.49,17.49,0,0,1,0-34.9c.39,0,.78,0,1.17,0A17.49,17.49,0,0,1,403.35,95.08Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M401,95.08a16.35,16.35,0,1,1-16.32-17.45A17.49,17.49,0,0,1,401,95.08Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 384.65,
    cy: 95.08,
    r: 13.08,
    transform: "translate(149.61 336.48) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M390.67,97.86c.51,2.9-1.48,4.83-5.06,5.14l-.06,2.39h-2.18l.06-2.39a12.05,12.05,0,0,1-5.29-1.68l1-2.7a10,10,0,0,0,4.39,1.55l.09-3.68c-2.13-.61-4.49-1.41-5-4-.5-2.9,1.52-4.85,5.18-5.11l.06-2.4h2.17L386,87.36a10.82,10.82,0,0,1,4.21,1.24l-.85,2.69a8.47,8.47,0,0,0-3.44-1.13L385.84,94C387.94,94.58,390.23,95.36,390.67,97.86Zm-7-4.48.08-3.13c-1.2.24-1.78.91-1.65,1.74S382.83,93.06,383.67,93.38Zm3.58,5.05c-.11-.63-.68-1-1.49-1.31l-.07,3C386.82,99.86,387.39,99.26,387.25,98.43Z",
    transform: "translate(0 -77.59)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Metric"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 239.69,
    y: 178.12,
    width: 59.17,
    height: 160.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 239.68,
    y: 177.96,
    width: 16.72,
    height: 160.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 180.45,
    y: 242.12,
    width: 59.17,
    height: 96.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 180.45,
    y: 242.12,
    width: 17.78,
    height: 95.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 121.23,
    y: 262.51,
    width: 59.17,
    height: 75.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 121.23,
    y: 262.51,
    width: 17.6,
    height: 75.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 62.04,
    y: 282.9,
    width: 59.17,
    height: 55.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 62.05,
    y: 282.85,
    width: 16.72,
    height: 55.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.92,132.08c-2.81,3.4-5.71,6.73-8.6,10l-2.19,2.48-2,2.19a6.82,6.82,0,0,0-1.52,3.45l-.66,6.46c-.22,2.19-.44,4.38-.69,6.56-.49,4.38-1,8.76-1.58,13.13a2.8,2.8,0,0,1-5.57-.21c-.25-4.4-.42-8.8-.57-13.19-.09-2.2-.13-4.4-.19-6.59l-.15-6.71a16.23,16.23,0,0,1,2.83-8.78l2.17-2.93,2-2.62c2.65-3.48,5.31-7,8-10.36a5.59,5.59,0,0,1,8.72,7Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M199.45,176.69l-3.66,6.21,8.42.85,1.48-6.3a1.34,1.34,0,0,0-1.06-1.63A6.82,6.82,0,0,0,199.45,176.69Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M195.79,182.9l.39,2.19a2.25,2.25,0,0,0,2.23,1.87h2.74a2.28,2.28,0,0,0,2-1.2l1.07-2Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "198.85 94.45 206.95 94.73 206.43 99.56 199.59 99.04 198.85 94.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "198.85 94.45 206.95 94.73 206.43 99.56 199.59 99.04 198.85 94.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M207,222.84l-1.33,2-1-2.07,2.43-31.4c.38-5-1.3-9.09-7.51-9.24-5.81-.14-9.33,3.83-9.74,8.81l-2.54,31.34-1.39,2-.95-2.06,2.56-31.33c.47-5.79,3-10.44,12.18-10.22s10.17,5,9.72,10.77Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M181.28,201.66h-1.6a6.63,6.63,0,0,0-6.61,5.78l-3,22.62,10.42.37Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.28,201.66h-1.6a6.63,6.63,0,0,0-6.61,5.78l-3,22.62,10.42.37Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M210.7,223.1l-2.35-.06.23-31.4c0-5-1.94-9.09-8.16-9.25-5.82-.14-9.06,3.83-9.12,8.81L191,222.55l-2.35-.07.37-31.33c.07-5.8,2.32-10.44,11.47-10.22s10.51,5,10.47,10.77Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M221.74,231.65l-46.3-1.38.44-23.34a5.29,5.29,0,0,1,5.4-5.27l33.72.88a7.12,7.12,0,0,1,6.86,7.17Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M216.61,231.5l-36.08-1.08a5.24,5.24,0,0,1-5-5.35l.37-18.14a5.29,5.29,0,0,1,5.4-5.27l33.72.88a7.12,7.12,0,0,1,6.86,7.17l-.1,16.71A5,5,0,0,1,216.61,231.5Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M210.7,223.1l-1.19,2L208.35,223l.23-31.4c0-5-1.94-9.09-8.16-9.25-5.82-.14-9.06,3.83-9.12,8.81L191,222.55l-1.25,2-1.1-2.06.37-31.33c.07-5.8,2.32-10.44,11.47-10.22s10.51,5,10.47,10.77Z",
    transform: "translate(0 -77.59)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "191.74 132.84 187.88 132.74 187.9 131.29 191.76 131.39 191.74 132.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "191.64 142.26 187.77 142.16 187.79 140.7 191.66 140.81 191.64 142.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "211.58 133.38 207.7 133.27 207.71 131.82 211.59 131.92 211.58 133.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "211.51 142.82 207.63 142.71 207.64 141.25 211.52 141.36 211.51 142.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "204.19 134.01 195.91 133.78 195.94 130.68 204.22 130.9 204.19 134.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M239.94,97c.32-.06.66.27.76.76s-.06.93-.38,1-.66-.27-.76-.75S239.62,97.05,239.94,97Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M240,97.4a1.68,1.68,0,0,0,.75-.83,1.49,1.49,0,0,1-1,.4A.57.57,0,0,1,240,97.4Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M240.64,102.29a2.81,2.81,0,0,0,2.21-.93,17.89,17.89,0,0,1-3.19-3.64Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M237.26,96.2a2.31,2.31,0,0,1,1.92-.86h.1a.29.29,0,0,0,.29-.3.3.3,0,0,0-.3-.29,2.91,2.91,0,0,0-2.44,1,.32.32,0,0,0-.07.19.31.31,0,0,0,.3.3A.29.29,0,0,0,237.26,96.2Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M234.22,125.1c-8.32.09-9.6-4.44-9.6-4.44,2.48-2.42,2.6-6.86,2.07-10.82a9.34,9.34,0,0,0,2.47,2.37c2,1.31,6.31-.79,6.31-.79s0,.73.06,1.8c.13,2.59.7,7.14,3.06,7.85C238.59,121.07,243.39,125,234.22,125.1Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M235.59,112.09c-.08.38-.17.77-.23,1.17a.21.21,0,0,1-.1,0,7.63,7.63,0,0,1-6.09-1.09,9.09,9.09,0,0,1-2.48-2.37c-.13-1-.31-2-.49-2.88l9.06,5Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M241.55,105.3a8.42,8.42,0,0,1-4.09,7.08h0l0,0a6.87,6.87,0,0,1-2,.86.21.21,0,0,1-.1,0,7.63,7.63,0,0,1-6.09-1.09,9.09,9.09,0,0,1-2.48-2.37c-1.63-2.24-2.31-5.22-3.48-9.42a8.3,8.3,0,0,1,9.45-10.49C239,91.05,241.68,99.68,241.55,105.3Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M237,112.55a4.4,4.4,0,0,1-1.47.67c-.06-1.07-.05-1.8-.06-1.8l.12-1.86S236.57,112.55,237,112.55Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M239.37,94c-.68,1.08-2.81,2-2.74,1.74.37-.89.3-2.61-.81-2.21.31.69,1.23,5.82.81,6.45-.23.34-.44,4.44-2.19,8.07-1.39,2.89-1.39,3.78-1.39,3.78l-5.68,1.1c-2.13-.27-4.11-3-4.28-3.28-.75-1.28-3-3-4.2-3.85a3.37,3.37,0,0,1-1.12-1.55c-.39-1.09.41-5,.58-6.87.25-2.65,1.64-5.11,5.5-6.69,2.38-1,4.38-3.12,6.82-4a8,8,0,0,1,7.37.74C239.05,88.18,241.07,91.26,239.37,94Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.4,97.69c1.75.52,2.66,3.1,2.74,4.73.08,1.81-1.12,3-2.7,1.74a6.89,6.89,0,0,1-2.42-3.69C233.6,98.7,234.65,97.18,236.4,97.69Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M238.51,103.72a.77.77,0,0,1-.77.76.76.76,0,0,1-.76-.76.77.77,0,0,1,.76-.77A.78.78,0,0,1,238.51,103.72Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M238.51,103.72a.77.77,0,0,1-.77.76.76.76,0,0,1-.76-.76.77.77,0,0,1,.76-.77A.78.78,0,0,1,238.51,103.72Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.24,123.66s1.29-4,3.24-5.25,10.51,0,11.85.58S240,122.6,240,122.6Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M222.24,123.66s1.29-4,3.24-5.25,10.51,0,11.85.58S240,122.6,240,122.6Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M241.78,122a27.31,27.31,0,0,0-3.22-.54,117.29,117.29,0,0,0-13.78.15,29.38,29.38,0,0,0-4.89.83,6.87,6.87,0,0,0-5.25,7.19c.68,9.36,3.44,14.86,3.85,21A99.28,99.28,0,0,1,217,174.36l6.3,1a63.81,63.81,0,0,0,24.9-5.32h0s-1.63-14.84-.06-20.19c4.29-14.62,1.5-16.93.66-21.11A8.56,8.56,0,0,0,241.78,122Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M248.15,149.8a29.81,29.81,0,0,0-.68,7.41c0,6,.74,12.79.74,12.79a63.63,63.63,0,0,1-24.9,5.32l-6.3-1a100.2,100.2,0,0,0,1.49-23.75c-.42-6.16-3.18-11.65-3.86-21a6.87,6.87,0,0,1,5.25-7.19,29.38,29.38,0,0,1,4.89-.83,121.82,121.82,0,0,1,13.78-.16,29.44,29.44,0,0,1,3.22.55,8.56,8.56,0,0,1,7,6.74c.3,1.5.86,2.77,1.24,4.44a22,22,0,0,1-.09,9.13A69.42,69.42,0,0,1,248.15,149.8Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.59,121.51c2.3.32,4.58.78,6.86,1.16s4.56.9,6.83,1.39l-.82-.07c1,0,1.91.12,2.47.16.27,0,.46,0,.39.06s-.15.06-.3.16a2.58,2.58,0,0,0-.68.53,2.4,2.4,0,0,0-.72,1.44c0,.23.07.17.08,0a6.76,6.76,0,0,0-.19-1.76l.1.29q-1.73-5-3.25-10.07c-1-3.39-1.91-6.81-2.57-10.33a2.49,2.49,0,0,1,4.56-1.78c1.9,3,3.54,6.17,5.13,9.33s3,6.36,4.45,9.59l.11.3a16.71,16.71,0,0,1,1,3.53,9,9,0,0,1,0,2.71,6.93,6.93,0,0,1-1.93,3.81,7.34,7.34,0,0,1-1.8,1.3,8.26,8.26,0,0,1-1.58.61,12.94,12.94,0,0,1-2.3.41c-1.25.12-2.17.12-3,.17h-.13l-.69-.08c-2.31-.24-4.62-.52-6.92-.81s-4.6-.61-6.89-1a5.59,5.59,0,0,1,1.76-11Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M243.59,121.51c2.3.32,4.58.78,6.86,1.16s4.56.9,6.83,1.39l-.82-.07c1,0,1.91.12,2.47.16.27,0,.46,0,.39.06s-.15.06-.3.16a2.58,2.58,0,0,0-.68.53,2.4,2.4,0,0,0-.72,1.44c0,.23.07.17.08,0a6.76,6.76,0,0,0-.19-1.76l.1.29q-1.73-5-3.25-10.07c-1-3.39-1.91-6.81-2.57-10.33a2.49,2.49,0,0,1,4.56-1.78c1.9,3,3.54,6.17,5.13,9.33s3,6.36,4.45,9.59l.11.3a16.71,16.71,0,0,1,1,3.53,9,9,0,0,1,0,2.71,6.93,6.93,0,0,1-1.93,3.81,7.34,7.34,0,0,1-1.8,1.3,8.26,8.26,0,0,1-1.58.61,12.94,12.94,0,0,1-2.3.41c-1.25.12-2.17.12-3,.17h-.13l-.69-.08c-2.31-.24-4.62-.52-6.92-.81s-4.6-.61-6.89-1a5.59,5.59,0,0,1,1.76-11Z",
    transform: "translate(0 -77.59)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "284.94 22.39 314.92 21.47 314.46 12.08 284.54 14.05 284.94 22.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "262.28 22.75 286.53 21.97 286.16 14.27 261.96 15.83 262.28 22.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "283.32 22.16 284.91 22.33 284.52 14.11 282.95 14.43 283.32 22.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "283.32 22.16 284.91 22.33 284.52 14.11 282.95 14.43 283.32 22.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "284.92 22.39 286.54 22.34 286.14 13.94 284.52 14.05 284.92 22.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "258.52 21.61 260.92 22.73 260.61 15.98 258.32 17.32 258.52 21.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "246.2 21.53 253.33 21.16 253.18 18 246.05 18.42 246.2 21.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "246.2 21.53 253.33 21.16 253.18 18 246.05 18.42 246.2 21.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "252.35 21.79 260.28 21.49 260.08 17.07 252.15 17.54 252.35 21.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "258.52 21.61 260.92 22.73 260.61 15.98 258.32 17.32 258.52 21.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "260.97 22.79 262.28 22.75 261.96 15.83 260.64 15.91 260.97 22.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "313.9 21.5 318.61 21.33 318.14 11.9 313.44 12.14 313.9 21.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M316,99.76l6-.17.15-.42a13.61,13.61,0,0,0-.7-10.84h0l-6,.41.13.31A15.32,15.32,0,0,1,316,99.76Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M309.6,90.71l2.42-.15.05,1-2.46.15A4,4,0,0,1,309.6,90.71Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M308.13,90.82a4.43,4.43,0,0,0,0,1L287.1,93,287,92.1Z",
    transform: "translate(0 -77.59)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "262.47 16.37 262.51 17.21 282.29 16.04 282.24 15.12 262.47 16.37"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "315.98 11.47 316.04 12.52 320.73 12.21 320.68 11.14 315.98 11.47"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M321.38,98.2a4.88,4.88,0,0,0,0,1.08l-4.85.16-.06-1Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M312.69,97.62a4,4,0,0,0,0,1L287,99.58l-.05-.94Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M282.05,98.52a4.71,4.71,0,0,0,0,.92l-19.13.67,0-.84Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.6,96.13l.06,3a1,1,0,0,0,1,.92l2.45,0-.1-4.94-2.45.09A1,1,0,0,0,244.6,96.13Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M257.27,104.51l.93-5.63a3.28,3.28,0,0,0,0-.7l-.27-3a1.06,1.06,0,0,0-.73-.89l-4.5,0a1.16,1.16,0,0,0-1.44.62l-.81,3.69a1.79,1.79,0,0,0,0,.83l1.34,5.08a1.26,1.26,0,0,0,1,.85l2.94,0A1.26,1.26,0,0,0,257.27,104.51Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "259.91 29.29 252.26 31.98 250.99 27.28 257.56 25.29 259.91 29.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "259.91 29.29 252.26 31.98 250.99 27.28 257.56 25.29 259.91 29.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M250,142.27l-5.86-11.06,6,1.93A22,22,0,0,1,250,142.27Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "280.17 156.49 278.95 171.51 285.79 171.64 287.67 156.16 280.17 156.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M286.87,247.17l-7.79.16a.65.65,0,0,0-.61.54l-1.34,6.84a1.11,1.11,0,0,0,.79,1.33l.22,0c2.81-.11,5.31-.32,8.81-.39,4.13-.08,3.09.47,7.95.45,2.92,0,3.42-3.6,2.18-3.75-5.69-.66-6.29-2.48-8.51-4.62A2.37,2.37,0,0,0,286.87,247.17Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "205.51 220.86 202.74 234.65 210.09 236.9 213.64 222.81 205.51 220.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M244.84,170.6s-10.46,61.07-16.15,79c-4,12.79-14.9,54.66-14.9,54.66L204,302.12s-1.1-28.5,4.37-43.21c1.87-5,4.31-9.55,5-12.66,2.82-13.29-3-37.4-.42-55.38a73.06,73.06,0,0,1,4.36-16.7Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M228.69,249.64c-4,12.79-14.9,54.66-14.9,54.66L204,302.12s-1.1-28.5,4.37-43.21c1.87-5,4.31-9.55,5-12.66,2.82-13.29-3-37.4-.42-55.38a73.06,73.06,0,0,1,4.36-16.7",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "232.01 111.89 237.28 132.57 241.13 112.79 232.01 111.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M288.15,241.28l-9.62.31s.71-12.59.71-31a34.1,34.1,0,0,1,1.06-8.12,46.78,46.78,0,0,1,3.59-9.79l-2.79.14c-5.44.28-39.16,2-39.82,2-.5-.05-3.57.36-9.06-2.32-10.21-5-10.31-19-10.31-19L248.2,170s.43.08,6.76.19c19.19.33,42.77,1.07,46.91,7.66C307.69,187.12,288.15,241.28,288.15,241.28Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M210.46,310.92l-8.06.1a.61.61,0,0,0-.6.54l-1,6.9a1.22,1.22,0,0,0,.9,1.35l.23,0c2.91-.09,5.48-.29,9.1-.34,4.28-.05,3.23.5,8.25.5,3,0,3.35-3.61,2.06-3.77-5.93-.69-6.66-2.54-9.07-4.71A2.61,2.61,0,0,0,210.46,310.92Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M280.3,202.52a46.78,46.78,0,0,1,3.59-9.79l-2.79.14a.71.71,0,0,0-.26-.05l7-.59Z",
    transform: "translate(0 -77.59)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Sun"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 96.54,
    cy: 37.9,
    r: 12.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 96.54,
    cy: 37.9,
    r: 12.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.56,98.55a1.83,1.83,0,0,1-1.82-1.83v-8a1.83,1.83,0,0,1,3.65,0v8A1.83,1.83,0,0,1,96.56,98.55Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.56,144a1.83,1.83,0,0,1-1.82-1.82v-8.06a1.83,1.83,0,0,1,3.65,0v8.06A1.83,1.83,0,0,1,96.56,144Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.36,104a1.81,1.81,0,0,1-1.29-.54L78.59,100a1.82,1.82,0,0,1,2.58-2.58l3.48,3.48a1.83,1.83,0,0,1,0,2.58A1.81,1.81,0,0,1,83.36,104Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113,133.67a1.86,1.86,0,0,1-1.29-.53l-3.24-3.25a1.82,1.82,0,0,1,2.58-2.58l3.24,3.25a1.82,1.82,0,0,1-1.29,3.11Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.89,117.22h-8a1.83,1.83,0,1,1,0-3.65h8a1.83,1.83,0,1,1,0,3.65Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.29,117.22h-8.05a1.83,1.83,0,1,1,0-3.65h8.05a1.83,1.83,0,1,1,0,3.65Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.29,133.5A1.81,1.81,0,0,1,79,133a1.83,1.83,0,0,1,0-2.58l3.07-3.07a1.82,1.82,0,0,1,2.58,2.58L81.58,133A1.81,1.81,0,0,1,80.29,133.5Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.77,104a1.79,1.79,0,0,1-1.29-.54,1.83,1.83,0,0,1,0-2.58l3.29-3.29a1.82,1.82,0,0,1,2.58,2.58l-3.29,3.29A1.83,1.83,0,0,1,109.77,104Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.56,98.55a1.83,1.83,0,0,1-1.82-1.83v-8a1.83,1.83,0,0,1,3.65,0v8A1.83,1.83,0,0,1,96.56,98.55Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.56,144a1.83,1.83,0,0,1-1.82-1.82v-8.06a1.83,1.83,0,0,1,3.65,0v8.06A1.83,1.83,0,0,1,96.56,144Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M83.36,104a1.81,1.81,0,0,1-1.29-.54L78.59,100a1.82,1.82,0,0,1,2.58-2.58l3.48,3.48a1.83,1.83,0,0,1,0,2.58A1.81,1.81,0,0,1,83.36,104Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M113,133.67a1.86,1.86,0,0,1-1.29-.53l-3.24-3.25a1.82,1.82,0,0,1,2.58-2.58l3.24,3.25a1.82,1.82,0,0,1-1.29,3.11Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M77.89,117.22h-8a1.83,1.83,0,1,1,0-3.65h8a1.83,1.83,0,1,1,0,3.65Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M123.29,117.22h-8.05a1.83,1.83,0,1,1,0-3.65h8.05a1.83,1.83,0,1,1,0,3.65Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M80.29,133.5A1.81,1.81,0,0,1,79,133a1.83,1.83,0,0,1,0-2.58l3.07-3.07a1.82,1.82,0,0,1,2.58,2.58L81.58,133A1.81,1.81,0,0,1,80.29,133.5Z",
    transform: "translate(0 -77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.77,104a1.79,1.79,0,0,1-1.29-.54,1.83,1.83,0,0,1,0-2.58l3.29-3.29a1.82,1.82,0,0,1,2.58,2.58l-3.29,3.29A1.83,1.83,0,0,1,109.77,104Z",
    transform: "translate(0 -77.59)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutD);
export default __webpack_public_path__ + "static/media/about-d.064ee446e294e778e9a3a609fbdd4d00.svg";
export { ForwardRef as ReactComponent };